import { Avatar, Button, Stack, Typography } from '@mui/material';
import { BlueX, NewBlueDelete, UploadWhite } from 'Images';
import { isDesktop } from 'react-device-detect';

interface IDuplicateFileButtons {
  deleteInvoice: () => void;
  newInvoice: () => void;
  deleteLabel: string;
  newInvoiceLabel: string;
}

export const DuplicateFileButtons = ({
  deleteInvoice,
  newInvoice,
  deleteLabel,
  newInvoiceLabel,
}: IDuplicateFileButtons) => (
  <Stack direction='row' justifyContent='center' gap='40px'>
    <Button
      variant='outlined'
      sx={{
        bgcolor: 'white',
        width: '234px',
        alignItems: 'center',
        gap: '4px',
        p: isDesktop ? '12px 0px' : '8px 0px',
        height: isDesktop ? undefined : '36px',
      }}
      onClick={deleteInvoice}
    >
      <Avatar alt='' src={BlueX} sx={{ width: '20px', height: '20px' }} />
      <Typography variant='body4'>{deleteLabel}</Typography>
    </Button>
    <Button
      variant='contained'
      sx={{
        bgcolor: '#3A6EEC',
        width: '234px',
        alignItems: 'center',
        gap: '4px',
        p: isDesktop ? '12px 0px' : '8px 0px',
        height: isDesktop ? undefined : '36px',
      }}
      onClick={newInvoice}
    >
      <Typography variant='body4'>{newInvoiceLabel}</Typography>
      <Avatar alt='' src={UploadWhite} sx={{ width: '20px', height: '20px' }} />
    </Button>
  </Stack>
);
